// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';

import { ResponsiveImage } from '@ta/media.image';

import styles from './LocationSectionPhotoWrap.less';

type Props = {
  /** The json location object */
  location: any,
  geoShelfPhotoClassName?: string,
};

const LocationSectionPhotoWrap = ({ location, geoShelfPhotoClassName }: Props) => (
  <div className={styles.photo_wrap}>
    <div className={geoShelfPhotoClassName !== '' ? geoShelfPhotoClassName : styles.photo}>
      <ResponsiveImage
        sources={location.thumbnail.photoSizes}
        width="100%"
        height="100%"
        borderRadius="2px"
      />
    </div>
  </div>
);

LocationSectionPhotoWrap.defaultProps = {
  geoShelfPhotoClassName: '',
};

export default LocationSectionPhotoWrap;
